const development_tenant = {
    notification: 'Geliştirme modundasın',
};
export default Object.freeze(development_tenant);
